import { routerConfig } from "~/solidJs/app/MainApp/models";
import { PaymentApi } from "../../api/PaymentApi";
import type { UserSubscriptionPlanEnum } from "../../helpers/types";
import { constructLinkWithParams } from "../../helpers/urlHelpres";

export type Params = {
	downgradeToType?: UserSubscriptionPlanEnum;
	downgradeToName?: string;
};

export const constructPricingUnsubscribeLink = (params: Params) => {
	const url = constructLinkWithParams<Params>(
		`${routerConfig.pricingPageUnsubscribeModal.absolute}`,
		params
	);
	return url;
};

export const openPricingUnsubscribePage = (params: Params = {}, target = "_blank") => {
	PaymentApi.logTryUnsubscribe();
	window.open(constructPricingUnsubscribeLink(params).href, target);
};
